import React from 'react';
import ReactDOM from 'react-dom';

import ModalAvaliacao from '../Atualizacao/ModalAvaliacao';
import ModalDemerito from '../Atualizacao/ModalDemerito';
import TabelaAvaliacoes from './TabelaAvaliacoes';

import './Style.css';

class ListaAvaliacoesOperador extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            notas: props.notas || [],
            demeritos: props.demeritos || [],
            user: props.user || {},
            userLoggedId: props.userLoggedId || null,
            cityPeriod: null,
            modalAvaliacaoOpen: false,
            avaliacaoLoading: false,
            selectedEvaluationToUpdate: null,
            modalDemeritoOpen: false,
            demeritoLoading: false,
            selectedDemeritToUpdate: null,
        };
    }

    handleAvaliacaoSubmit = async (form) => {
        this.setState({
            avaliacaoLoading: true,
        });

        try {
            const payload = {
                tipo: 'Avaliação',
                base_id: form.base_id,
                motivos: (form.motivos || []).map(
                    (item) => item.id
                ),
                comentario: form.comentario || null,
            };

            if (form.id) {
                await axios.put(
                    `/atualizar-avaliacao/${form.id}`,
                    payload
                );
            } else {
                await axios.post(
                    `/salvar-avaliacao`,
                    payload
                );
            }

            alert('Avaliação atualizada com sucesso');

            window.location.reload();
        } catch (error) {
            console.error('Erro ao atualizar avaliação:', error);

            this.setState({
                avaliacaoLoading: false,
            });
        }
    };

    handleDemeritoSubmit = async (form) => {
        this.setState({
            demeritoLoading: true,
        });

        const {
            cityPeriod,
        } = this.state;

        try {
            const payload = {
                tipo: 'Demérito',
                operador_id: this.state.user.id,
                building_id: form.building_id,
                city_period_id: cityPeriod.id,
                motivos: (form.motivos || []).map(
                    (item) => item.id
                ),
                comentario: form.comentario || null,
            };

            if (form.id) {
                await axios.put(
                    `/atualizar-avaliacao/${form.id}`,
                    payload
                );
            } else {
                await axios.post(
                    `/salvar-demerito`,
                    payload
                );
            }

            alert('Demérito atualizado com sucesso');

            window.location.reload();
        } catch (error) {
            console.error('Erro ao salvar demérito:', error);

            this.setState({
                demeritoLoading: false,
            });
        }
    };

    showModalAvaliacao = (id = null) => {
        this.setState({
            modalAvaliacaoOpen: true,
            selectedEvaluationToUpdate: id
        });
    };

    closeModalAvaliacao = () => {
        this.setState({
            modalAvaliacaoOpen: false,
            selectedEvaluationToUpdate: null
        });
    };

    showModalDemerito = async (id = null, cityPeriodId = null) => {
        this.setState({
            modalDemeritoOpen: true,
            selectedDemeritToUpdate: id,
            cityPeriod: cityPeriodId
        });
    };

    closeModalDemerito = () => {
        this.setState({
            modalDemeritoOpen: false,
            selectedDemeritToUpdate: null,
            cityPeriod: null
        });
    };

    render() {
        const {
            loading,
            notas,
            demeritos,
            user,
            userLoggedId,
            modalAvaliacaoOpen,
            avaliacaoLoading,
            selectedEvaluationToUpdate,
            modalDemeritoOpen,
            demeritoLoading,
            selectedDemeritToUpdate,
            cityPeriod,
        } = this.state;

        return (
            <div>
                <div className="card-updated">
                    <div className="card-body tabela-avaliacoes">
                        {loading ? (
                            <div className="text-center">
                                <i className="fa fa-spinner fa-spin"></i>
                            </div>
                        ) : (
                            <TabelaAvaliacoes
                                user={user}
                                userLoggedId={userLoggedId}
                                notas={notas}
                                demeritos={demeritos}
                                onShowModalAvaliacao={this.showModalAvaliacao}
                                onShowModalDemerito={this.showModalDemerito}
                            />
                        )}

                        <ModalAvaliacao
                            open={modalAvaliacaoOpen}
                            onClose={this.closeModalAvaliacao}
                            onSubmit={this.handleAvaliacaoSubmit}
                            evaluationId={selectedEvaluationToUpdate}
                            loading={avaliacaoLoading}
                        />

                        <ModalDemerito
                            open={modalDemeritoOpen}
                            onClose={this.closeModalDemerito}
                            onSubmit={this.handleDemeritoSubmit}
                            demeritId={selectedDemeritToUpdate}
                            cityPeriod={cityPeriod}
                            loading={demeritoLoading}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

const element = document.getElementById('app-lista-avaliacoes-operador');

if (element) {
    const props = {
        notas: JSON.parse(element.dataset.notas || '[]'),
        demeritos: JSON.parse(element.dataset.demeritos || '[]'),
        user: JSON.parse(element.dataset.user || '{}'),
        userLoggedId: JSON.parse(element.dataset.userlogged || ''),
    };

    ReactDOM.render(<ListaAvaliacoesOperador {...props} />, element);
}
export default ListaAvaliacoesOperador;